/** @format */

const sortRequests = (key, salesParams, prop) => {
  switch (true) {
    case key === 'CLIENTE':
      prop = 'clientName';
      if (salesParams.orderBy.prop === prop) {
        salesParams.orderBy.direction =
          salesParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        salesParams.orderBy.prop = prop;
      } else {
        salesParams.orderBy.prop = prop;
      }
      break;
    case key === 'STATO':
      prop = 'status';
      if (salesParams.orderBy.prop === prop) {
        salesParams.orderBy.direction =
          salesParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        salesParams.orderBy.prop = prop;
      } else {
        salesParams.orderBy.prop = prop;
      }
      break;
    case key === 'OGG. VENDUTI':
      prop = 'items';
      if (salesParams.orderBy.prop === prop) {
        salesParams.orderBy.direction =
          salesParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        salesParams.orderBy.prop = prop;
      } else {
        salesParams.orderBy.prop = prop;
      }
      break;
    case key === 'TOT.':
      prop = 'tot';
      if (salesParams.orderBy.prop === prop) {
        salesParams.orderBy.direction =
          salesParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        salesParams.orderBy.prop = prop;
      } else {
        salesParams.orderBy.prop = prop;
      }
      break;
    case key === 'DATA E ORA':
      prop = 'timestamp';
      if (salesParams.orderBy.prop === prop) {
        salesParams.orderBy.direction =
          salesParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        salesParams.orderBy.prop = prop;
      } else {
        salesParams.orderBy.prop = prop;
      }
      break;
    default:
  }
  return salesParams;
};

export default sortRequests;
